
YP.TicketOfficeManager = function() {
    return {
        sendData: function(url) {
            var autoscan = $('#autoscan_ticketoffice');
            var displayQuotaTicketoffice = $('#display_quota_ticketoffice');
            var autoscanScanlistId = $('#autoscan_ticketoffice_scanlist_id');
            var requiringAttendeeDetailsOnTicketoffice = $('#requiring_attendee_details_on_ticketoffice');
            var params = {};

            if (autoscan !== 'undefined') {
                params['autoscan'] = autoscan.is(':checked');
            }

            if (displayQuotaTicketoffice !== 'undefined') {
                params['displayQuotaTicketoffice'] = displayQuotaTicketoffice.is(':checked');
            }

            if (params['autoscan'] && autoscanScanlistId !== 'undefined') {
                params['autoscan_scanlist_id'] = $('#autoscan_ticketoffice_scanlist_id').val();
            }

            if (requiringAttendeeDetailsOnTicketoffice !== 'undefined') {
                params['requiring_attendee_details_on_ticketoffice'] = requiringAttendeeDetailsOnTicketoffice.is(':checked');
            }

            $.post(url, params, function(data) {});
        },
        init: function() {
                autoscanUrl = $('#autoscan_ticketoffice').data('url');
                requiringAttendeeDetailsOnTicketofficeUrl = $('#requiring_attendee_details_on_ticketoffice').data('url');

                YP.TicketOfficeManager().autoscanScanlistSelectorShowHandler();

                $('#autoscan_ticketoffice').on('change', function(){
                    YP.TicketOfficeManager().sendData(autoscanUrl);
                    YP.TicketOfficeManager().autoscanScanlistSelectorShowHandler();
                });
    
                $('#display_quota_ticketoffice').on('change', function(){
                    YP.TicketOfficeManager().sendData(autoscanUrl);
                });
    
                $('#autoscan_ticketoffice_scanlist_id').on('change', function() {
                    YP.TicketOfficeManager().sendData(autoscanUrl);
                });

                $('#requiring_attendee_details_on_ticketoffice').on('change', function(){
                    YP.TicketOfficeManager().sendData(requiringAttendeeDetailsOnTicketofficeUrl);
                });
        },
        autoscanScanlistSelectorShowHandler: function() {
            //display autoscan_ticketoffice_scanlist_id selector
            if ($('#autoscan_ticketoffice').is(':checked')) {
                $('.js-autoscan_ticketoffice_scanlist_id_selector').show();
            }
            else {
                $('.js-autoscan_ticketoffice_scanlist_id_selector').hide();
                $('#autoscan_ticketoffice_scanlist_id option:selected').removeAttr('selected');
            }
        }
    };
}

window.addEventListener("load", function(){
    if($('#autoscan_ticketoffice').length > 0 && $('#requiring_attendee_details_on_ticketoffice').length > 0){
      YP.TicketOfficeManager().init();
    }
});
